// Client Pages
import MainPage from '../Pages/Website/MainPage';
import { Navigate, useParams } from 'react-router-dom';
import SearchPage from '../Pages/Website/Search';
import { PUBLIC_TICKET_SEARCH_PATHS } from '../Pages/Website/Search/ticketSearchUrl';
import ServicesPage from '../Pages/Website/Services';
import ContactPage from '../Pages/Website/Contact';
import ErrorPage from '../Pages/Website/Error/ErrorPage';
import PaymentSuccessPage from '../Pages/Website/Payer/Success';
import MaintenancePage from '../Pages/Website/Error/Maintenance';
import LoginPage from '../Pages/Website/Login';
import PrivacyPolicyPage from '../Pages/Website/PrivacyPolicy';

export const LegacyPaymentRedirect = () => {
    const { id = '' } = useParams();
    return <Navigate to={`/payez-un-avis?avis=${encodeURIComponent(id)}`} replace />;
};

// Admin Pages
import Avis from '../Pages/Dashboard/Avis';
import Default from '../Pages/Dashboard/MainPage';
import SingleAvis from '../Pages/Dashboard/Avis/SingleAvis';
import Users from '../Pages/Dashboard/Users';
import CurrentUserProfile from '../Pages/Dashboard/Users/CurrentUserProfile';
import SingleUser from '../Pages/Dashboard/Users/SingleUser';
import AddUser from '../Pages/Dashboard/Users/AddUser';
import Timesheets from '../Pages/Dashboard/Users/Timesheets';
import CodingWorkTimesheet from '../Pages/Dashboard/Users/Timesheets/CodingWork';
import Contracts from '../Pages/Dashboard/Contracts';
import SingleContract from '../Pages/Dashboard/Contracts/SingleContract';
import AddContract from '../Pages/Dashboard/Contracts/AddContract';
import AdminSearchPage from '../Pages/Dashboard/SearchPage';

import ReportAvisPage from '../Pages/Dashboard/Reports/Avis';
import ReportUsersPage from '../Pages/Dashboard/Reports/Users';
import ReportsContractPage from '../Pages/Dashboard/Reports/Contrats';
import ReportHeatMapPage from '../Pages/Dashboard/Reports/Heatmap';
import ReportHistoryPage from '../Pages/Dashboard/Reports/History';
import DailyHealthReportPage from '../Pages/Dashboard/Reports/DailyHealth';
import ExpenseReportPage from '../Pages/Dashboard/Reports/Expenses';
import VehicleAlertsPage from '../Pages/Dashboard/VehicleAlerts';

import MobileAvisSettings from '../Pages/Dashboard/Mobile';

export const routes = [

    // Client Routes
    { path: '/', Component: <MainPage />, type: "client" },
    ...PUBLIC_TICKET_SEARCH_PATHS.map((path) => ({ path, Component: <SearchPage />, type: "client" })),
    { path: '/payer/:id', Component: <LegacyPaymentRedirect />, type: "client" },
    { path: '/services', Component: <ServicesPage />, type: "client" },
    { path: '/contact', Component: <ContactPage />, type: "client" },
    { path: '/politique-de-confidentialite', Component: <PrivacyPolicyPage />, type: "client" },
    { path: '/payer/success/:token', Component: <PaymentSuccessPage />, type: "client" },
    { path: '/auth', Component: <LoginPage />, type: "client" },

    // Dashboard Routes - full /dashboard paths
    { path: '/dashboard', Component: <Default />, type: "dashboard", user: "admin" },
    { path: '/dashboard/home', Component: <Default />, type: "dashboard", user: "admin" },
    { path: '/dashboard/avis', Component: <Avis />, type: "dashboard", user: "admin" },
    { path: '/dashboard/avis/:id', Component: <SingleAvis />, type: "dashboard", user: "admin" },
    { path: '/dashboard/contracts', Component: <Contracts />, type: "dashboard", user: "admin" },
    { path: '/dashboard/contracts/add', Component: <AddContract />, type: "dashboard", user: "admin" },
    { path: '/dashboard/contracts/:id', Component: <SingleContract />, type: "dashboard", user: "admin" },
    { path: '/dashboard/users', Component: <Users />, type: "dashboard", user: "admin" },
    { path: '/dashboard/users/add', Component: <AddUser />, type: "dashboard", user: "admin" },
    { path: '/dashboard/users/activite-terrain', Component: <Timesheets />, type: "dashboard", user: "admin" },
    { path: '/dashboard/users/activite-terrain/coding-work', Component: <CodingWorkTimesheet />, type: "dashboard", user: "admin" },
    { path: '/dashboard/users/timesheets', Component: <Navigate to="/dashboard/users/activite-terrain" replace />, type: "dashboard", user: "admin" },
    { path: '/dashboard/users/:id', Component: <SingleUser />, type: "dashboard", user: "admin" },
    { path: '/dashboard/app/users/userProfile', Component: <CurrentUserProfile />, type: "dashboard", user: "admin" },
    { path: '/dashboard/app/users/:id', Component: <SingleUser />, type: "dashboard", user: "admin" },
    { path: '/dashboard/reports/avis', Component: <ReportAvisPage />, type: "dashboard", user: "admin" },
    { path: '/dashboard/reports/users', Component: <ReportUsersPage />, type: "dashboard", user: "admin" },
    { path: '/dashboard/reports/contrats', Component: <ReportsContractPage />, type: "dashboard", user: "admin" },
    { path: '/dashboard/reports/heatmap', Component: <ReportHeatMapPage />, type: "dashboard", user: "admin" },
    { path: '/dashboard/reports/history', Component: <ReportHistoryPage />, type: "dashboard", user: "admin" },
    { path: '/dashboard/reports/daily-health', Component: <DailyHealthReportPage />, type: "dashboard", user: "admin" },
    { path: '/dashboard/reports/expenses', Component: <ExpenseReportPage />, type: "dashboard", user: "admin" },
    { path: '/dashboard/alertes-vehicules', Component: <VehicleAlertsPage />, type: "dashboard", user: "admin" },
    { path: '/dashboard/vehicle-alerts', Component: <VehicleAlertsPage />, type: "dashboard", user: "admin" },
    { path: '/admin/reports', Component: <DailyHealthReportPage />, type: "dashboard", user: "admin" },
    { path: '/dashboard/search', Component: <AdminSearchPage />, type: "dashboard", user: "admin" },
    { path: '/dashboard/search/:terms', Component: <AdminSearchPage />, type: "dashboard", user: "admin" },
    { path: '/dashboard/mobile', Component: <MobileAvisSettings />, type: "dashboard", user: "admin" },

    // Backward-compatible dashboard aliases
    { path: '/home', Component: <Default />, type: "dashboard", user: "admin" },
    { path: '/avis', Component: <Avis />, type: "dashboard", user: "admin" },
    { path: '/avis/:id', Component: <SingleAvis />, type: "dashboard", user: "admin" },
    { path: '/contracts', Component: <Contracts />, type: "dashboard", user: "admin" },
    { path: '/contracts/add', Component: <AddContract />, type: "dashboard", user: "admin" },
    { path: '/contracts/:id', Component: <SingleContract />, type: "dashboard", user: "admin" },
    { path: '/users', Component: <Users />, type: "dashboard", user: "admin" },
    { path: '/users/add', Component: <AddUser />, type: "dashboard", user: "admin" },
    { path: '/users/activite-terrain', Component: <Timesheets />, type: "dashboard", user: "admin" },
    { path: '/users/activite-terrain/coding-work', Component: <CodingWorkTimesheet />, type: "dashboard", user: "admin" },
    { path: '/users/timesheets', Component: <Navigate to="/users/activite-terrain" replace />, type: "dashboard", user: "admin" },
    { path: '/users/:id', Component: <SingleUser />, type: "dashboard", user: "admin" },
    { path: '/reports/avis', Component: <ReportAvisPage />, type: "dashboard", user: "admin" },
    { path: '/reports/users', Component: <ReportUsersPage />, type: "dashboard", user: "admin" },
    { path: '/reports/contrats', Component: <ReportsContractPage />, type: "dashboard", user: "admin" },
    { path: '/reports/heatmap', Component: <ReportHeatMapPage />, type: "dashboard", user: "admin" },
    { path: '/reports/history', Component: <ReportHistoryPage />, type: "dashboard", user: "admin" },
    { path: '/reports/daily-health', Component: <DailyHealthReportPage />, type: "dashboard", user: "admin" },
    { path: '/reports/expenses', Component: <ExpenseReportPage />, type: "dashboard", user: "admin" },
    { path: '/alertes-vehicules', Component: <VehicleAlertsPage />, type: "dashboard", user: "admin" },
    { path: '/vehicle-alerts', Component: <VehicleAlertsPage />, type: "dashboard", user: "admin" },
    { path: '/search', Component: <AdminSearchPage />, type: "dashboard", user: "admin" },
    { path: '/search/:terms', Component: <AdminSearchPage />, type: "dashboard", user: "admin" },
    { path: '/mobile', Component: <MobileAvisSettings />, type: "dashboard", user: "admin" },

    // Catch-all must stay last
    { path: '*', Component: <ErrorPage />, type: "client" }
];
